export function GenerateNoteNumber(NoteType, date, NoteNumber) {
  const noteno = `${NoteType}-${date}${String(NoteNumber)}`;

  return noteno;
}